// Release gates: features that are built and merged but not yet approved for
// production. Hide the triggers only — surfaces that display feature-created
// data are already dark, because that data can't exist while the trigger is off.
// Releasing is a deletion, not a flip: remove the entry and everything listed
// under it in one PR. `production: true` should never be committed.
// KB: /planning/release-gating-vs-feature-flags.md
//
// 'ai-retouching' (CH-4300) — AI post-production tooling, CH-4231/4255/4259/4267/4269/4304.
//
//   Visible entry points
//     · AI Generation button ......... screens/FullAssetScreen/components/Header
//     · AI Generation tab + panel .... modals/UploadVersionModal — "New version" / "New asset"
//       mode toggle; asset mode mints a new asset from this asset as base (CH-4304)
//     · "Show AI Assets Only" toggle . components/Gallery (filter dropdown)
//                                     + screens/ServiceJob/AssetsAndResources/Related
//                                       (filter popup, CH-4235)
//     · version delete control ....... modals/UploadVersionModal/components/VersionList (CH-4269)
//
//   Work that starts on mount
//     · loadAssetPrompts fetch ....... modals/UploadVersionModal (shouldPerformFn)
//
//   Deliberately NOT gated — leave these alone
//     · AI badges in GridItem / VersionList / AssetDetails — driven by the
//       ai_request_id blob flag, which no production blob carries while the
//       triggers above are off. Inert by construction.
//     · the VersionList "Base" row + aiLineage read (CH-4304) — same inertia:
//       the row only renders for assets with AI lineage, which can't exist in
//       production while the generation trigger is off; the read returns null
//       for every normal asset.
//     · useBlobMetadata / useAiGeneratedContentIds — shared read path. The
//       general metadata panel in GridItem and ListView already ships in
//       production and reads the same hook; gating it would break live behaviour.
//     · the CH-4248 ClientGenerated hide — a hide, and there is nothing to hide
//       until the client portal's AI Studio rolls out.
//
// 'delivered-indicator' (CH-4278) — the "v{n} - not sent yet" line on asset cards.
//
//   Display fed by data that already exists in production
//     · the whole <Text> block .... components/Gallery/GridView/GridItem
//
//   Unlike the AI badges above, this one is NOT inert: it reads service-job
//   statuses and histories that production already has, so it would appear the
//   moment it merged. The gate drops the element rather than its text — the
//   hidden state reserves the line, so leaving it would change every card's height.
//   The DELIVERED_STATUS_ID extraction into functions/isCurrentVersionDelivered
//   is a refactor with no behaviour of its own; nothing to gate.
const features = {
  'ai-retouching': {
    development: true,
    // ON on staging for feature testing (CH-4304); the gate itself was verified
    // with a temporary OFF. Both entries go at rollout.
    production: false,
    staging: true,
  },
  'delivered-indicator': {
    development: true,
    production: false,
    staging: false,
  },
}

// An env the map doesn't list resolves to OFF.
export const isFeatureEnabled = name => features[name]?.[process.env.REACT_APP_APPLICATION_ENV] === true

export default isFeatureEnabled
